// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__E51fu","link":"Footer_link__tCNhL","mailTo":"Footer_mailTo__nfG7e"};